import React, { useState,useEffect } from "react";
import { Radio } from "antd";
import { findCombinations } from "../../pages/constant/utils";
import { ProductVariantDisplayType } from "../../pages/constant/Constants";

const RadioButtonVarient = ({
  variant_attribute,
  values,
  setValues,
  product,
  index,
  setVariantRadio,
  FindDisplayType
}) => {
  const onChange = (e) => {
    setValues((prev) => ({
      ...prev,
      [variant_attribute.name]: e.target.value,
    }));
    setVariantRadio(e.target.value);
  };

  const deSelectedVariant = (obj) => {
    if (
      Object.keys(values).includes(variant_attribute.name) &&
      values[variant_attribute.name] === obj[variant_attribute.name]
    ) {
      setValues((prev) => {
        delete prev[variant_attribute.name];
        return prev;
      });
    }
    return true;
  };

  return (
    <div className="frame-wrapper">
      <div className="div-10">
        <div style={{display:"flex", justifyContent:"space-between"}}>
            <label
              style={{
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontWeight: "500",
              lineHeight: "22px",
              letterSpacing: "0em",
              textAlign: "left",
              }}
            >
              {variant_attribute.name}
            </label>
              {variant_attribute?.attachment ?
              <a href={variant_attribute.attachment} target="_blank">
              <img src={process.env.PUBLIC_URL + "/media/icons/size_guide_img.png"} style={{height:"24px", width:"24px"}} alt="" />
            <label 
                style={{
                fontFamily: "Montserrat",
                fontSize: "18px",
                fontWeight: "400",
                lineHeight: "22px",
                letterSpacing: "0em",
                textAlign: "left",
                marginLeft: "8px",
                cursor: "pointer",
            }}>
                {variant_attribute?.attachment_name}
            </label>
            </a>
            : null
            }
          </div>
        {variant_attribute.value.map((e) => (
          <Radio.Group
            className="custom-radio"
            onChange={onChange}
            disabled={
              findCombinations({
                data:
                  [
                    { ...product, variant_product: null },
                    ...product?.variant_product,
                  ] || [],
                index,
                variantAttributes: product.product_variant_attribute,
                values,
                availability: {
                  [variant_attribute.name]: e,
                },
              })?.length
                ? false
                : deSelectedVariant({
                    [variant_attribute.name]: e,
                  })
            }
            value={values?.[variant_attribute.name] || ""}
            size="large"
            style={{ margin: "20px 16px 16px 0px" }}
          >
            <Radio value={e}>
              {findCombinations({
                data:
                  [
                    { ...product, variant_product: null },
                    ...product?.variant_product,
                  ] || [],
                index,
                variantAttributes: product.product_variant_attribute,
                values,
                availability: {
                  [variant_attribute.name]: e,
                },
              })?.length ? (
                e
              ) : (
                <span style={{ position: "relative" }}>{e}<span style={{
                  position: "absolute", top: "50%", left: "0px", width: "100%", height: "1px", backgroundColor: "black", transform: "rotate(-25deg)",
                }}></span></span>
              )}
            </Radio>
          </Radio.Group>
        ))}
      </div>
    </div>
  );
};
export default RadioButtonVarient;